/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface History {
  id: number
  objectType: HistoryObjectTypeEnum
  objectId: string
  actionType: HistoryActionTypeEnum
  userId: string
  userName: string
  date: string
  createdDate?: string
  lastModifiedDate?: string
}

export const HistoryObjectTypeEnum = {
  NOTE: "NOTE",
  SCORE: "SCORE",
  MEMENTO: "MEMENTO"
} as const

export type HistoryObjectTypeEnum =
  (typeof HistoryObjectTypeEnum)[keyof typeof HistoryObjectTypeEnum]
export const HistoryActionTypeEnum = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DUPLICATE: "DUPLICATE",
  UPDATE_STATUS: "UPDATE_STATUS",
  UPDATE_SCORE: "UPDATE_SCORE",
  REMOVE_OUTIL: "REMOVE_OUTIL",
  PUBLISH_MEMENTO: "PUBLISH_MEMENTO",
  UNPUBLISH_MEMENTO: "UNPUBLISH_MEMENTO",
  UPDATE_MEMENTO: "UPDATE_MEMENTO"
} as const

export type HistoryActionTypeEnum =
  (typeof HistoryActionTypeEnum)[keyof typeof HistoryActionTypeEnum]
